import { render, staticRenderFns } from "./DetailsToolbar.vue?vue&type=template&id=22a516ac"
import script from "./DetailsToolbar.vue?vue&type=script&lang=ts"
export * from "./DetailsToolbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports